export default __webpack_public_path__ + "media/images/payments/mastercard-2-7cd075345cd2ce449b7b264947c48b34.svg";